import { render, staticRenderFns } from "./SectionLoader.vue?vue&type=template&id=e3639246&scoped=true&"
import script from "./SectionLoader.vue?vue&type=script&lang=ts&"
export * from "./SectionLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLoader.vue?vue&type=style&index=0&id=e3639246&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3639246",
  null
  
)

export default component.exports